var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeThreeDotsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#DEA829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 9.2807C8.7069 9.2807 9.27997 8.70763 9.27997 8.0007C9.27997 7.29378 8.7069 6.7207 7.99997 6.7207C7.29305 6.7207 6.71997 7.29378 6.71997 8.0007C6.71997 8.70763 7.29305 9.2807 7.99997 9.2807Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16 9.2807C4.86693 9.2807 5.44 8.70763 5.44 8.0007C5.44 7.29378 4.86693 6.7207 4.16 6.7207C3.45308 6.7207 2.88 7.29378 2.88 8.0007C2.88 8.70763 3.45308 9.2807 4.16 9.2807Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8399 9.2807C12.5469 9.2807 13.1199 8.70763 13.1199 8.0007C13.1199 7.29378 12.5469 6.7207 11.8399 6.7207C11.133 6.7207 10.5599 7.29378 10.5599 8.0007C10.5599 8.70763 11.133 9.2807 11.8399 9.2807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeThreeDotsIcon);
export default __webpack_public_path__ + "static/media/orange-three-dots-icon.e309b0ff1f6b9a67c492987a98d445d9.svg";
export { ForwardRef as ReactComponent };